import { render, staticRenderFns } from "./AttentItem.vue?vue&type=template&id=61e6ea5a&scoped=true&"
import script from "./AttentItem.vue?vue&type=script&lang=js&"
export * from "./AttentItem.vue?vue&type=script&lang=js&"
import style0 from "./AttentItem.vue?vue&type=style&index=0&id=61e6ea5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61e6ea5a",
  null
  
)

export default component.exports